module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Tag 标签")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--普通标签-->\n<span class=\"tag\">tag</span>\n<!--完成标签-->\n<span class=\"tag success\">sucess</span>\n<!--信息标签-->\n<span class=\"tag info\">info</span>\n<!--警告标签-->\n<span class=\"tag warning\">warning</span>\n<!--提醒标签-->\n<span class=\"tag alert\">alert</span>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("tag")]), _vm._v(" "), _c('span', {
    staticClass: "tag success"
  }, [_vm._v("sucess")]), _vm._v(" "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticClass: "tag warning"
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    staticClass: "tag alert"
  }, [_vm._v("alert")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f1a538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/tag.vue
// module id = 397
// module chunks = 1